import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const CellIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <path
            d="M10.7754 1.22449C10.7754 0.548223 11.3236 0 11.9999 0C12.6761 0 13.2244 0.548223 13.2244 1.22449V20.2015C13.2244 20.8778 12.6761 21.426 11.9999 21.426C11.3236 21.426 10.7754 20.8778 10.7754 20.2015V1.22449Z"
            fill="currentColor"
         />
         <path
            d="M19.592 1.22449C19.592 0.548223 20.1403 0 20.8165 0C21.4928 0 22.041 0.548223 22.041 1.22449V20.2015C22.041 20.8778 21.4928 21.426 20.8165 21.426C20.1403 21.426 19.592 20.8778 19.592 20.2015V1.22449Z"
            fill="currentColor"
         />
         <path
            d="M15.1836 1.22449C15.1836 0.548223 15.7318 0 16.4081 0C17.0844 0 17.6326 0.548223 17.6326 1.22449V20.2015C17.6326 20.8778 17.0844 21.426 16.4081 21.426C15.7318 21.426 15.1836 20.8778 15.1836 20.2015V1.22449Z"
            fill="currentColor"
         />
         <path
            d="M6.36719 1.22449C6.36719 0.548223 6.91541 0 7.59168 0C8.26794 0 8.81617 0.548223 8.81617 1.22449V20.2015C8.81617 20.8778 8.26794 21.426 7.59168 21.426C6.91541 21.426 6.36719 20.8778 6.36719 20.2015V1.22449Z"
            fill="currentColor"
         />
         <path
            d="M1.95923 1.22449C1.95923 0.548223 2.50745 0 3.18372 0C3.85999 0 4.40821 0.548223 4.40821 1.22449V20.2015C4.40821 20.8778 3.85999 21.426 3.18372 21.426C2.50745 21.426 1.95923 20.8778 1.95923 20.2015V1.22449Z"
            fill="currentColor"
         />
         <path
            d="M1.15246 21.426C0.515974 21.426 -2.39636e-08 20.9101 -5.35241e-08 20.2736C-8.30847e-08 19.6371 0.515973 19.1211 1.15246 19.1211L22.8475 19.1211C23.484 19.1211 24 19.6371 24 20.2736C24 20.9101 23.484 21.426 22.8475 21.426L1.15246 21.426Z"
            fill="currentColor"
         />
         <path
            d="M1.15246 2.30501C0.515974 2.30501 -2.39636e-08 1.78904 -5.35241e-08 1.15255C-8.30847e-08 0.516068 0.515973 9.48694e-05 1.15246 9.48432e-05L22.8475 9.39506e-05C23.484 9.39245e-05 24 0.516067 24 1.15255C24 1.78904 23.484 2.30501 22.8475 2.30501L1.15246 2.30501Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default CellIcon
